/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you are an app developer and requires the theme to re-render the mini-cart, you can trigger your own event. If
 * you are adding a product, you need to trigger the "product:added" event, and make sure that you pass the quantity
 * that was added so the theme can properly update the quantity:
 *
 * document.documentElement.dispatchEvent(new CustomEvent('product:added', {
 *   bubbles: true,
 *   detail: {
 *     quantity: 1
 *   }
 * }));
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */

/* Sticky Add to Cart on mobile — only activates after user scrolls past the button */
(function() {
  var style = document.createElement('style');
  style.textContent = [
    '@media screen and (max-width: 768px) {',
    '  .product-form__payment-container.is-sticky {',
    '    position: fixed;',
    '    bottom: 0;',
    '    left: 0;',
    '    right: 0;',
    '    z-index: 999;',
    '    background: #ffffff;',
    '    box-shadow: 0 -2px 10px rgba(0, 0, 0, 0.1);',
    '    padding: 10px 15px;',
    '    padding-bottom: calc(10px + env(safe-area-inset-bottom, 0px));',
    '    margin: 0;',
    '    animation: slideUp 0.3s ease;',
    '  }',
    '  .product-form__payment-container.is-sticky .product-form__add-button,',
    '  .product-form__payment-container.is-sticky .shopify-payment-button {',
    '    width: 100%;',
    '  }',
    '  .product-form__payment-container.is-sticky .shopify-payment-button {',
    '    margin-top: 8px;',
    '  }',
    '  .product-form__buy-buttons.has-sticky-placeholder {',
    '    padding-bottom: 80px;',
    '  }',
    '  @keyframes slideUp {',
    '    from { transform: translateY(100%); }',
    '    to { transform: translateY(0); }',
    '  }',
    '}'
  ].join('\n');
  document.head.appendChild(style);

  function initStickyCart() {
    var container = document.querySelector('.product-form__payment-container');
    if (!container) return;

    var parent = container.closest('.product-form__buy-buttons') || container.closest('.product-info__block-item--buy-buttons');
    if (!parent) return;

    /* Create a sentinel element that stays in the normal flow.
       We observe this instead of the container itself to avoid the
       sticky toggle loop (element leaves flow -> observer fires -> repeat). */
    var sentinel = document.createElement('div');
    sentinel.style.height = '1px';
    sentinel.style.width = '100%';
    sentinel.style.pointerEvents = 'none';
    parent.insertBefore(sentinel, container);

    var observer = new IntersectionObserver(function(entries) {
      entries.forEach(function(entry) {
        if (entry.isIntersecting) {
          container.classList.remove('is-sticky');
          parent.classList.remove('has-sticky-placeholder');
        } else if (entry.boundingClientRect.top < 0) {
          container.classList.add('is-sticky');
          parent.classList.add('has-sticky-placeholder');
        }
      });
    }, { threshold: 0 });

    observer.observe(sentinel);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initStickyCart);
  } else {
    initStickyCart();
  }
})();

/* --- Mobile mini-cart fix (Claude, 26 Aug) ---------------------------------
 * The sticky Add to Cart bar above is position:fixed, z-index:999, applied at
 * <=768px. On phones (<=640px) the mini-cart is a FULL-SCREEN panel at
 * z-index:2 whose "Checkout" / "View cart" buttons sit flush with the bottom
 * of the viewport -- exactly where the sticky bar sits. The opaque white bar
 * therefore covered those buttons, so a tap meant for "View cart" landed on
 * "Add to cart" instead. That produced both reported symptoms: items appearing
 * to re-add from the mini-cart, and no way to reach the main cart.
 *
 * Fix: hide the sticky bar while the mini-cart (or any drawer/popover) is open.
 * No z-index changes, so nothing else re-layers.
 */
(function() {
  var style = document.createElement('style');
  style.textContent =
    '.product-form__payment-container.is-sticky.kh-overlay-open{display:none !important;}';
  document.head.appendChild(style);

  var OPEN_SELECTOR = '#mini-cart[aria-hidden="false"],.mini-cart[aria-hidden="false"],.drawer[aria-hidden="false"]';

  function syncOverlayState() {
    var open = !!document.querySelector(OPEN_SELECTOR);
    var bars = document.querySelectorAll('.product-form__payment-container');
    for (var i = 0; i < bars.length; i++) {
      bars[i].classList.toggle('kh-overlay-open', open);
    }
  }

  function watchOverlays() {
    var targets = document.querySelectorAll('#mini-cart, .mini-cart, .drawer');
    if (!targets.length) return;
    var mo = new MutationObserver(syncOverlayState);
    for (var i = 0; i < targets.length; i++) {
      mo.observe(targets[i], { attributes: true, attributeFilter: ['aria-hidden'] });
    }
    syncOverlayState();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', watchOverlays);
  } else {
    watchOverlays();
  }
})();
